// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"195":"989bf591","408":"8f87dced","665":"6a303c6e","986":"341152fb"}[chunkId] + ".chunk.js";
};